import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-m-3" }
const _hoisted_2 = { class: "p-formgrid p-grid" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "maxTotal",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = {
  for: "maxWait",
  class: "kn-material-input-label"
}
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "maxWait",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "abandonedTimeout",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  for: "timeBetweenEvictionRuns",
  class: "kn-material-input-label"
}
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = {
  for: "minEvictableIdleTimeMillis",
  class: "kn-material-input-label"
}
const _hoisted_15 = { class: "p-formgrid p-grid" }
const _hoisted_16 = { class: "p-float-label" }
const _hoisted_17 = {
  for: "validationQuery",
  class: "kn-material-input-label"
}
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = {
  for: "validationQueryTimeout",
  class: "kn-material-input-label"
}
const _hoisted_20 = { class: "p-field-checkbox" }
const _hoisted_21 = { for: "removeAbandonedOnBorrow" }
const _hoisted_22 = { class: "p-field-checkbox" }
const _hoisted_23 = { for: "removeAbandonedOnMaintenance" }
const _hoisted_24 = { class: "p-field-checkbox" }
const _hoisted_25 = { for: "logAbandoned" }
const _hoisted_26 = { class: "p-field-checkbox" }
const _hoisted_27 = { for: "testOnReturn" }
const _hoisted_28 = { class: "p-field-checkbox" }
const _hoisted_29 = { for: "testWhileIdle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Card = _resolveComponent("Card")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Card, {
    style: _ctx.dataSourceDescriptor.card.style
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.title')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "p-field p-col-12 p-md-6 p-lg-4 p-xl-3",
            style: _ctx.dataSourceDescriptor.pField.style
          }, [
            _createVNode("span", _hoisted_3, [
              _withDirectives(_createVNode(_component_InputText, {
                id: "maxTotal",
                class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.jdbcPoolConfiguration.maxTotal.$invalid && _ctx.v$.jdbcPoolConfiguration.maxTotal.$dirty
                                }],
                type: "number",
                maxLength: "20",
                modelValue: _ctx.v$.jdbcPoolConfiguration.maxTotal.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.jdbcPoolConfiguration.maxTotal.$model = $event)),
                modelModifiers: { trim: true },
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.jdbcPoolConfiguration.maxTotal.$touch())),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFieldChange('maxTotal', $event.target.value))),
                disabled: _ctx.readOnly
              }, null, 8, ["modelValue", "class", "disabled"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('managers.dataSourceManagement.form.advancedOptions.maxTotalInfo'),
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.maxTotal')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.jdbcPoolConfiguration.maxTotal,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.dataSourceManagement.form.advancedOptions.maxTotal') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ], 4),
          _createVNode("div", {
            class: "p-field p-col-12 p-md-6 p-lg-4 p-xl-3",
            style: _ctx.dataSourceDescriptor.pField.style
          }, [
            _createVNode("span", _hoisted_5, [
              _withDirectives(_createVNode(_component_InputText, {
                id: "maxWait",
                class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.jdbcPoolConfiguration.maxWait.$invalid && _ctx.v$.jdbcPoolConfiguration.maxWait.$dirty
                                }],
                type: "number",
                maxLength: "30",
                modelValue: _ctx.v$.jdbcPoolConfiguration.maxWait.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.jdbcPoolConfiguration.maxWait.$model = $event)),
                modelModifiers: { trim: true },
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.jdbcPoolConfiguration.maxWait.$touch())),
                onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFieldChange('maxWait', $event.target.value))),
                disabled: _ctx.readOnly
              }, null, 8, ["modelValue", "class", "disabled"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('managers.dataSourceManagement.form.advancedOptions.maxWaitInfo'),
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.maxWait')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.jdbcPoolConfiguration.maxWait,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.dataSourceManagement.form.advancedOptions.maxWait') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ], 4),
          _createVNode("div", {
            class: "p-field p-col-12 p-md-6 p-lg-4 p-xl-3",
            style: _ctx.dataSourceDescriptor.pField.style
          }, [
            _createVNode("span", _hoisted_7, [
              _withDirectives(_createVNode(_component_InputText, {
                id: "maxIdle",
                class: "kn-material-input",
                type: "number",
                maxLength: "30",
                modelValue: _ctx.jdbcPoolConfiguration.maxIdle,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.jdbcPoolConfiguration.maxIdle = $event)),
                modelModifiers: { trim: true },
                onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onFieldChange('maxIdle', $event.target.value))),
                disabled: _ctx.readOnly
              }, null, 8, ["modelValue", "disabled"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('managers.dataSourceManagement.form.advancedOptions.maxIdleInfo'),
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.maxIdle')) + " * ", 1)
            ])
          ], 4),
          _createVNode("div", {
            class: "p-field p-col-12 p-md-6 p-lg-4 p-xl-3",
            style: _ctx.dataSourceDescriptor.pField.style
          }, [
            _createVNode("span", _hoisted_9, [
              _withDirectives(_createVNode(_component_InputText, {
                id: "abandonedTimeout",
                class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.jdbcPoolConfiguration.abandonedTimeout.$invalid && _ctx.v$.jdbcPoolConfiguration.abandonedTimeout.$dirty
                                }],
                type: "number",
                maxLength: "20",
                modelValue: _ctx.v$.jdbcPoolConfiguration.abandonedTimeout.$model,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.jdbcPoolConfiguration.abandonedTimeout.$model = $event)),
                modelModifiers: { trim: true },
                onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.jdbcPoolConfiguration.abandonedTimeout.$touch())),
                onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onFieldChange('abandonedTimeout', $event.target.value))),
                disabled: _ctx.readOnly
              }, null, 8, ["modelValue", "class", "disabled"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('managers.dataSourceManagement.form.advancedOptions.abandonedTimeoutInfo'),
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.abandonedTimeout')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.jdbcPoolConfiguration.abandonedTimeout,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.dataSourceManagement.form.advancedOptions.abandonedTimeout') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ], 4),
          _createVNode("div", {
            class: "p-field p-col-12 p-md-6 p-lg-4 p-xl-3",
            style: _ctx.dataSourceDescriptor.pField.style
          }, [
            _createVNode("span", _hoisted_11, [
              _withDirectives(_createVNode(_component_InputText, {
                id: "timeBetweenEvictionRuns",
                class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.jdbcPoolConfiguration.timeBetweenEvictionRuns.$invalid && _ctx.v$.jdbcPoolConfiguration.timeBetweenEvictionRuns.$dirty
                                }],
                type: "number",
                maxLength: "30",
                modelValue: _ctx.v$.jdbcPoolConfiguration.timeBetweenEvictionRuns.$model,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.jdbcPoolConfiguration.timeBetweenEvictionRuns.$model = $event)),
                modelModifiers: { trim: true },
                onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.jdbcPoolConfiguration.timeBetweenEvictionRuns.$touch())),
                onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onFieldChange('timeBetweenEvictionRuns', $event.target.value))),
                disabled: _ctx.readOnly
              }, null, 8, ["modelValue", "class", "disabled"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('managers.dataSourceManagement.form.advancedOptions.timeBetweenEvictionRunsInfo'),
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.timeBetweenEvictionRuns')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.jdbcPoolConfiguration.timeBetweenEvictionRuns,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.dataSourceManagement.form.advancedOptions.timeBetweenEvictionRuns') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ], 4),
          _createVNode("div", {
            class: "p-field p-col-12 p-md-6 p-lg-4 p-xl-3",
            style: _ctx.dataSourceDescriptor.pField.style
          }, [
            _createVNode("span", _hoisted_13, [
              _withDirectives(_createVNode(_component_InputText, {
                id: "minEvictableIdleTimeMillis",
                class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.jdbcPoolConfiguration.minEvictableIdleTimeMillis.$invalid && _ctx.v$.jdbcPoolConfiguration.minEvictableIdleTimeMillis.$dirty
                                }],
                disabled: _ctx.readOnly,
                type: "number",
                maxLength: "30",
                modelValue: _ctx.v$.jdbcPoolConfiguration.minEvictableIdleTimeMillis.$model,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.jdbcPoolConfiguration.minEvictableIdleTimeMillis.$model = $event)),
                modelModifiers: { trim: true },
                onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.v$.jdbcPoolConfiguration.minEvictableIdleTimeMillis.$touch())),
                onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onFieldChange('minEvictableIdleTimeMillis', $event.target.value)))
              }, null, 8, ["disabled", "modelValue", "class"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('managers.dataSourceManagement.form.advancedOptions.minEvictableIdleTimeMillisInfo'),
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.minEvictableIdleTimeMillis')), 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.jdbcPoolConfiguration.minEvictableIdleTimeMillis,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.dataSourceManagement.form.advancedOptions.minEvictableIdleTimeMillis') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ], 4)
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", {
            class: "p-field p-col-9",
            style: _ctx.dataSourceDescriptor.pField.style
          }, [
            _createVNode("span", _hoisted_16, [
              _createVNode(_component_InputText, {
                id: "validationQuery",
                class: "kn-material-input",
                disabled: _ctx.readOnly,
                type: "text",
                modelValue: _ctx.jdbcPoolConfiguration.validationQuery,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.jdbcPoolConfiguration.validationQuery = $event)),
                modelModifiers: { trim: true },
                maxLength: "200",
                onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onFieldChange('validationQuery', $event.target.value)))
              }, null, 8, ["disabled", "modelValue"]),
              _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.validationQuery')), 1)
            ])
          ], 4),
          _createVNode("div", {
            class: "p-field p-col-3",
            style: _ctx.dataSourceDescriptor.pField.style
          }, [
            _createVNode("span", _hoisted_18, [
              _withDirectives(_createVNode(_component_InputText, {
                id: "validationQueryTimeout",
                class: "kn-material-input",
                disabled: _ctx.readOnly,
                type: "number",
                maxLength: "30",
                modelValue: _ctx.jdbcPoolConfiguration.validationQueryTimeout,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.jdbcPoolConfiguration.validationQueryTimeout = $event)),
                modelModifiers: { trim: true },
                onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onFieldChange('validationQueryTimeout', $event.target.value)))
              }, null, 8, ["disabled", "modelValue"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('managers.dataSourceManagement.form.advancedOptions.validationQueryTimeoutInfo'),
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.validationQueryTimeout')), 1)
            ])
          ], 4)
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode(_component_Checkbox, {
            id: "removeAbandonedOnBorrow",
            modelValue: _ctx.jdbcPoolConfiguration.removeAbandonedOnBorrow,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.jdbcPoolConfiguration.removeAbandonedOnBorrow = $event)),
            disabled: _ctx.readOnly,
            binary: true,
            onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onFieldChange('removeAbandonedOnBorrow', _ctx.jdbcPoolConfiguration.removeAbandonedOnBorrow)))
          }, null, 8, ["modelValue", "disabled"]),
          _withDirectives(_createVNode("label", _hoisted_21, [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.removeAbandonedOnBorrow')), 1)
          ], 512), [
            [
              _directive_tooltip,
              _ctx.$t('managers.dataSourceManagement.form.advancedOptions.removeAbandonedOnBorrowInfo'),
              void 0,
              { top: true }
            ]
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_Checkbox, {
            id: "removeAbandonedOnMaintenance",
            modelValue: _ctx.jdbcPoolConfiguration.removeAbandonedOnMaintenance,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.jdbcPoolConfiguration.removeAbandonedOnMaintenance = $event)),
            disabled: _ctx.readOnly,
            binary: true,
            onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onFieldChange('removeAbandonedOnMaintenance', _ctx.jdbcPoolConfiguration.removeAbandonedOnMaintenance)))
          }, null, 8, ["modelValue", "disabled"]),
          _withDirectives(_createVNode("label", _hoisted_23, [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.removeAbandonedOnMaintenance')), 1)
          ], 512), [
            [
              _directive_tooltip,
              _ctx.$t('managers.dataSourceManagement.form.advancedOptions.removeAbandonedOnMaintenanceInfo'),
              void 0,
              { top: true }
            ]
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode(_component_Checkbox, {
            id: "logAbandoned",
            modelValue: _ctx.jdbcPoolConfiguration.logAbandoned,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.jdbcPoolConfiguration.logAbandoned = $event)),
            disabled: _ctx.readOnly,
            binary: true,
            onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onFieldChange('logAbandoned', _ctx.jdbcPoolConfiguration.logAbandoned)))
          }, null, 8, ["modelValue", "disabled"]),
          _withDirectives(_createVNode("label", _hoisted_25, [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.logAbandoned')), 1)
          ], 512), [
            [
              _directive_tooltip,
              _ctx.$t('managers.dataSourceManagement.form.advancedOptions.logAbandonedInfo'),
              void 0,
              { top: true }
            ]
          ])
        ]),
        _createVNode("div", _hoisted_26, [
          _createVNode(_component_Checkbox, {
            id: "testOnReturn",
            modelValue: _ctx.jdbcPoolConfiguration.testOnReturn,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.jdbcPoolConfiguration.testOnReturn = $event)),
            disabled: _ctx.readOnly,
            binary: true,
            onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onFieldChange('testOnReturn', _ctx.jdbcPoolConfiguration.testOnReturn)))
          }, null, 8, ["modelValue", "disabled"]),
          _withDirectives(_createVNode("label", _hoisted_27, [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.testOnReturn')), 1)
          ], 512), [
            [
              _directive_tooltip,
              _ctx.$t('managers.dataSourceManagement.form.advancedOptions.testOnReturnInfo'),
              void 0,
              { top: true }
            ]
          ])
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode(_component_Checkbox, {
            id: "testWhileIdle",
            modelValue: _ctx.jdbcPoolConfiguration.testWhileIdle,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.jdbcPoolConfiguration.testWhileIdle = $event)),
            disabled: _ctx.readOnly,
            binary: true,
            onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onFieldChange('testWhileIdle', _ctx.jdbcPoolConfiguration.testWhileIdle)))
          }, null, 8, ["modelValue", "disabled"]),
          _withDirectives(_createVNode("label", _hoisted_29, [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.dataSourceManagement.form.advancedOptions.testWhileIdle')), 1)
          ], 512), [
            [
              _directive_tooltip,
              _ctx.$t('managers.dataSourceManagement.form.advancedOptions.testWhileIdleInfo'),
              void 0,
              { top: true }
            ]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}